/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import {
    SET_FETCH_TOUR_IMAGES_STATUS,
    FETCH_TOUR_IMAGES_SUCCESS,
    FETCH_TOUR_IMAGES_ERROR,
} from '../actions/tourImagesActions';

export const initialState = {
    loadingStatus: STATUS.IDLE,
    isLoading: true,
    error: null,
};

export const tourImagesReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_TOUR_IMAGES_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_TOUR_IMAGES_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
                error: null,
            };
        }
        case FETCH_TOUR_IMAGES_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        default:
            return state;
    }
};
